import { Translations } from '../../../typings';

import { showroomApi } from './api';

export const loadTranslations = async () => showroomApi.QUERY_GET('/translation')({});
export const updateTranslations = async (data: Translations.TranslationsDTOAdditional) => showroomApi.QUERY_POST('/translation')({ data });
